import { createStore, createHook } from "react-sweet-state";
import { execute } from "./utils/loadFromBackend";

const refreshIntervalInSeconds = 0;

const Store = createStore({
  initialState: {},
  actions: {
    load:
      (queryParameters = []) =>
      ({ getState, setState }) => {
        return execute(
          { getState, setState },
          {
            key: "luvat",
            queryParameters
          },
          {},
          refreshIntervalInSeconds
        );
      },

    loadWithPaging:
      (pageNo = 1, pageSize = 20, additionalParams = []) =>
      ({ getState, setState }) => {
        // Combine pagination and additional parameters
        const queryParameters = [
          { key: "pageNo", value: pageNo },
          { key: "pageSize", value: pageSize },
          ...additionalParams
        ];

        return execute(
          { getState, setState },
          {
            key: "luvatByJarjestaja",
            // Käytetään erillistä polkua ("paged") tilassa, jotta sivutettu data
            // ei törmää koulutusmuotokohtaisten lupahakujen ("load") dataan.
            path: ["paged"],
            queryParameters
          },
          { pageNo, pageSize }, // propsToState for cache invalidation
          refreshIntervalInSeconds
        );
      }
  },
  name: "Luvat"
});

export const useLuvat = createHook(Store);
